module.exports = __webpack_public_path__ + "img/select-clear.5dfe0458.svg";